import React from "react";
import { Controller } from "react-hook-form";
import CustomFormSelect from "components/bootstrap/CustomSelectControl";
import { Col, FloatingLabel, Row } from "react-bootstrap";

// look at scss reset here in stlyes.scss
// react-bootstrap-floating-label reset

type SelectInsideReactHookFormProps = {
  name: string;
  control: any;
  rules?: Record<string, any>;
  defaultValue?: string;
  options: {
    value: string | number;
    label: string;
    isDisabled?: boolean;
  }[];
  label?: string;
  error?: string;
  isRowNeeded?: boolean;
  isLabelNedded?: boolean;
  isFloatingLabel?: boolean;
  className?: string;
};

const SelectInsideReactHookForm = ({
  name,
  control,
  rules,
  defaultValue = "",
  options,
  label,
  error,
  isRowNeeded = true,
  isLabelNedded = true,
  isFloatingLabel = true,
  className,
}: SelectInsideReactHookFormProps) => {
  const controller = (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <>
          <CustomFormSelect
            name={name}
            value={value ?? defaultValue}
            onChange={onChange}
            aria-label={label}
            className={className}
          >
            <option disabled value="">
              {label}
            </option>
            {options.map((option) => {
              return (
                <option
                  key={option.value}
                  value={option.value}
                  disabled={option?.isDisabled}
                >
                  {option.label}
                </option>
              );
            })}
          </CustomFormSelect>
          {error && <span className="requiredField">*{error}</span>}
        </>
      )}
    />
  );
  return (
    <FloatingLabel controlId={name} label={label && isFloatingLabel && label}>
      {isLabelNedded && label}
      {isRowNeeded ? (
        <Row className="violation-type-container default-vertical-padding">
          <Col sm={3.5}>{controller}</Col>
        </Row>
      ) : (
        controller
      )}
    </FloatingLabel>
  );
};

export default SelectInsideReactHookForm;
